import { siteCall } from "../utils/WebCall";
import urls from '../utils/urls'


export const getTeamAdmins = async(successCallback, errorCallback) => {
  return siteCall({
      url: urls.get_team_admin_url,
      method: "GET",
      body: {},
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}

export const getReport = async(params, successCallback, errorCallback) => {
    return siteCall({
        url: urls.get_report_url,
        method: "POST",
        body: JSON.stringify(params),
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
  }